import { useTranslation } from 'react-i18next';
import { CAMERA_EVENT_SEVERITY_COLOR, type ICameraEvent } from '@interfaces/ICameras';
import { ScrollArea } from '@components/ui/ScrollArea/ScrollArea';
import { StatusDot } from '@components/ui/StatusDot/StatusDot';
import { AlertIcon, VideoIcon, CameraIcon, ClockIcon, MapPinIcon, CloseIcon } from '@utils/icons';
import styles from './EventsPanel.module.css';

interface IEventsPanelProps {
  events: ICameraEvent[];
  onClose: () => void;
}

export function EventsPanel({ events, onClose }: IEventsPanelProps) {
  const { t } = useTranslation();

  return (
    <aside className={styles.panel}>
      <header className={styles.header}>
        <div className={styles.titleRow}>
          <AlertIcon size={15} />
          <h2 className={styles.title}>{t('cameras.events.title')}</h2>
        </div>
        <button type="button" className={styles.close} onClick={onClose} aria-label={t('cameras.events.close')}>
          <CloseIcon size={14} />
        </button>
      </header>

      <ScrollArea className={styles.listScroll}>
        <ul className={styles.list}>
          {events.length === 0 && (
            <li className={styles.empty}>{t('cameras.events.empty')}</li>
          )}
          {events.map((event) => (
            <li key={event.id} className={styles.card} data-severity={event.severity}>
              <div className={styles.cardHead}>
                <StatusDot color={CAMERA_EVENT_SEVERITY_COLOR[event.severity]} />
                <span className={styles.eventTitle}>{event.title}</span>
              </div>

              <div className={styles.meta}>
                <span className={styles.metaItem}><ClockIcon size={12} />{event.time}</span>
                <span className={styles.metaItem}><VideoIcon size={12} />{event.cameraId}</span>
              </div>
              <div className={styles.meta}>
                <span className={styles.metaItem}><MapPinIcon size={12} />{event.location}</span>
              </div>

              <div className={styles.snapshot}>
                <CameraIcon size={22} />
              </div>
            </li>
          ))}
        </ul>
      </ScrollArea>
    </aside>
  );
}
